import React from "react";

interface Props extends React.ComponentProps<"div"> {
  children: JSX.Element;
  type: "left" | "right"; // Might become useful later for ID/testing etc.
}

export const SideBar = ({ children, style, type, ...props }: Props) => {
  return (
    <div
      {...props}
      style={{ maxWidth: "100%", ...style }}
      id={`layout-sidebar-${type}`}
    >
      {children}
    </div>
  );
};

export default SideBar;
